<template>
  <el-dialog title="纠偏记录" :visible.sync="dialogVisible" v-loading="loading" :before-close="handleClose">
    <div class="content">
      <div class="base_info">
        <div class="left">
          <span class="label">
            班组名称：</span>
          <span class="value">{{ info.teamName }}</span>
        </div>
        <div class="right">
          <span class="label">签到项目：</span>
          <span class="value">{{ info.projectName }}</span>
        </div>
      </div>
      <div class="img">
        <el-image :src="info.signImage" :preview-src-list="[info.signImage]" fit="fill" ref="preview">
        </el-image>
      </div>
      <div class="row">
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/sign_count_gray.svg">
            识别人数：
          </span>
          <span class="value">{{ info.systemIdentifyNum || 0 }}人</span>
        </div>
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/sign_count.svg">
            纠偏人数：
          </span>
          <span class="value">{{ info.modifyNum }}人</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/sign.svg">
            {{ info.signType === '1' ? '上班签到' : '下班签到' }}：
          </span>
          <span class="value">{{ info.signTime }}</span>
        </div>
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/correct.svg">
            纠偏时间：
          </span>
          <span class="value">{{ info.createTime }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/sign_address.svg">
            签到地点：
          </span>
          <span class="value">{{ info.signAddress }}</span>
        </div>
        <div class="item">
          <span class="label">
            <img src="@/assets/img/attendance/correct_person.svg">
            纠偏人：
          </span>
          <span class="value">{{ info.createUserName }}</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'CorrectListDetails',
  props: {
    id: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      info: {}
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },
  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhTeamSignModifyLogByModifyId, { modifyId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      }).finally(() => {
        // this.loading = false
      })
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:detailsShow', false)
      this.info = {}
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 10px;
  width: 521px;
  height: 519px;
}

.el-image {
  width: 100%;
  height: 100%;
}

.content {
  padding: 10px;
  font-size: 12px;
  height: 430px;
  overflow-y: auto;
  overflow-x: hidden;

  .base_info {
    line-height: 30px;
    display: flex;
    font-size: 14px;

    .left,
    .right {
      display: flex;

      .label {
        width: 80px;
      }

      .value {
        flex: 1;
      }
    }

    .left {
      width: 200px;
    }

    .right {
      flex: 1;
    }
  }

  .img {
    width: 453px;
    height: 242px;
    background-color: skyblue;
    margin: 15px 0;
  }

  .row {
    display: flex;
    line-height: 30px;

    .item {
      flex: 1;
      display: flex;
      // align-items: center;
      line-height: 30px;
      margin-bottom: 10px;

      .label {
        width: 85px;
        display: flex;
        align-items: center;
        height: 25px;
        line-height: 25px;

        img {
          margin-right: 5px;
        }
      }

      .value {
        flex: 1;
        line-height: 25px;
        padding-right: 10px;
      }
    }
  }
}
</style>
